import React from 'react';

import '../../sass/components/charts/BreakdownView.scss';

export default class BreakdownView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render = () => {
    const data = this.props.data || {};
    return (
      <div className='breakdownView'>
        {Object.keys(data).map(key =>
          <div key={key} className='breakdownItem'>
            <label>{key}</label>
            <div className='ratingContainer'>
              {['poor', 'good', 'superb'].map(type =>
                <div
                  key={type}
                  className={`ratingValue ${type}`}
                  style={{width: `${data[key][type] || 0}%`}}
                />
              )}
            </div>
            <div className='breakdownInfo'>
              {['poor', 'good', 'superb'].map(type =>
                <div
                  key={type}
                  className={`ratingValue ${type}`}
                >{data[key][type] || 0}%</div>
              )}
            </div>
          </div>
        )}
      </div>
    )
  }

}
